/**
 * Created by fyzu on 22.08.16.
 */


var GoogleMapsService = (function () {
    //slider shop list

    $('.find-shop-list').on('init', function () {
        $('.find-shop-list-wrap').addClass('init');
    });

    $('.find-shop-list').slick({
        arrows: false,
        dots: true,
        fade: true,
        rows: 5,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    rows: 4
                }
            },
            {
                breakpoint: 1367,
                settings: {
                    rows: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    rows: 6
                }
            }
        ]
    });


    var width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    if (width < 768) {
        $('.find-shop .tab-content>div').addClass('tab-pane');
        $('.find-shop .tab-content>div:first-of-type').addClass('active');

        $("#find-shop-tab a").click(function (e) {
            e.preventDefault();
            $(this).tab('show');
        });
    }


    var infoWindow = null;
    var styles = [
        {
            "featureType": "landscape",
            "stylers": [
                {
                    "saturation": -100
                }, {
                    "lightness": 40
                }, {
                    "visibility": "on"
                }
            ]
        }, {
            "featureType": "poi",
            "stylers": [
                {
                    "saturation": -100
                }, {
                    "lightness": 40
                }, {
                    "visibility": "simplified"
                }
            ]
        }, {
            "featureType": "road.highway",
            "stylers": [
                {
                    "saturation": -100
                }, {
                    "visibility": "simplified"
                }
            ]
        }, {
            "featureType": "road.arterial",
            "stylers": [
                {
                    "saturation": -100
                }, {
                    "lightness": 20
                }, {
                    "visibility": "on"
                }
            ]
        }, {
            "featureType": "road.local",
            "stylers": [
                {
                    "saturation": -100
                }, {
                    "lightness": 30
                }, {
                    "visibility": "on"
                }
            ]
        }, {
            "featureType": "transit",
            "stylers": [
                {
                    "saturation": -100
                }, {
                    "visibility": "simplified"
                }
            ]
        }, {
            "featureType": "administrative.province",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }, {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }, {
                    "lightness": -25
                }, {
                    "saturation": -100
                }
            ]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "hue": "#ffff00"
                }, {
                    "lightness": -25
                }, {
                    "saturation": -97
                }
            ]
        }
    ];


    async function getMarkerColorAsync(shopId) {
        try {
            return await $.ajax({
                url: '/api/v1/shop/' + shopId + '/marker/color',
                type: 'GET',
            })
        } catch (error) {
            console.log('Error:', error);
        }
    }


    function createShopMarker(map, id, title, position, content) {

        if (infoWindow == null) {
            infoWindow = new google.maps.InfoWindow({
                content: ''
            });
        }


        getMarkerColorAsync(id)
            .then(data => {
                const mark = {
                    url: '/static/sv/img/' + data.result.markerColor + '-map-marker.png',
                    scaledSize: new google.maps.Size(40, 40)
                };
                var marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    icon: mark,
                    title: title,
                    id: id
                });
                marker.addListener('click', function () {
                    infoWindow.close();
                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);

                    $('.find-shop-list-item').each(function () {
                        if (marker.id === $(this).attr('data-id')) {
                            var index = $(this).closest('.slick-slide').attr('data-slick-index');
                            $('.find-shop-list').slick('slickGoTo', index);
                            $('.find-shop-list-item').removeClass('active');
                            $(this).addClass('active');
                        }
                    });
                });

                $(".js-map-marker[data-id='" + id + "']").click(function () {
                    map.setCenter(position);
                    map.setZoom(15);

                    infoWindow.close();
                    infoWindow.setContent(content);
                    infoWindow.open(map, marker);

                    $('.find-shop-list-item').removeClass('active');
                    $(this).addClass('active');

                    $('.nav-tabs a[href="#panel1"]').tab('show');

                    $("a[href='#panel1']").on('shown.bs.tab', function () {
                        google.maps.event.trigger(map, 'resize');
                    });


                });
            });
    }

    function init() {
        const mapElement = $('.js-google-map');
        if (mapElement.length) {
            new google.maps.Geocoder().geocode({'address': AppService.getCurrentCity()}, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var cityLocationLat = parseFloat(results[0].geometry.location.lat());
                    var cityLocationLng = parseFloat(results[0].geometry.location.lng());

                    var map = new google.maps.Map(mapElement[0], {
                        center: {lat: cityLocationLat, lng: cityLocationLng},
                        zoom: 11
                    });
                    /*map.setOptions({styles: styles});*/

                    $.each(GoogleMapsMarkers, function (index, item) {
                        createShopMarker(map, item.id, item.title, item.position, item.content);
                        var elem = '#' + item.id;
                        $(elem.toString()).rating({
                            displayOnly: true, step: 0.1,
                            filledStar: '<i class="fa fa-star"></i>',
                            emptyStar: '<i class="fa fa-star-o"></i>'
                        });
                    });
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                    AppService.redirectToBack();
                }
            });
        }


    }

    return {
        init: init,
        styles: styles,
        createShopMarker: createShopMarker
    }
})();

$(GoogleMapsService.init);
